import i18n from 'i18next';

export interface SelectOptionLike {
  value: string | number;
  label: string;
}

interface SelectWithLabelOptions {
  labelKey: string;
  options: SelectOptionLike[];
  separator?: string;
}

const norm = (v: unknown) => String(v ?? '');

export const selectWithLabel =
  ({ labelKey, options, separator = ': ' }: SelectWithLabelOptions) =>
  ({ value }: { value: unknown }) => {
    if (value === undefined || value === null || value === '') return null;

    const map = new Map<string, string>();
    for (const opt of options) {
      map.set(norm(opt.value), opt.label);
    }

    const normalizedValue = norm(value);
    const labelValue = map.get(normalizedValue);

    return `${i18n.t(labelKey)}${separator}${labelValue ?? normalizedValue}`;
  };
